import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IAbsenceGroup, ICreateAbsenceGroupApplicationRequest, ICreateAbsenceGroupRequest, ISearchAbsenceGroupsRequest, IUpdateAbsenceGroupStateRequest } from '../models/absence-group';
import { map } from 'rxjs';
import { IEmployee } from 'src/app/employee/employee';

@Injectable({
  providedIn: 'root'
})
export class AbsenceGroupService {

  constructor(
    private http: HttpClient
  ) { }

    createAbsenceGroup(request: ICreateAbsenceGroupRequest){
      return this.http.post<string>(
        `${environment.baseUrl}/v1/AbsenceGroup/createAbsenceGroup`,
        request
      )
    }

    applyAbsenceGroup(request: ICreateAbsenceGroupApplicationRequest){
      return this.http.post<string>(
        `${environment.baseUrl}/v1/AbsenceGroup/applyAbsenceGroup`,
        request
      )
    }

    updateAbsenceGroupState(request: IUpdateAbsenceGroupStateRequest){
      return this.http.post<string>(
        `${environment.baseUrl}/v1/AbsenceGroup/updateAbsenceGroupState`,
        request
      )
    }

    searchAbsenceGroups(request: ISearchAbsenceGroupsRequest){
      return this.http.post<IPagedResults<IAbsenceGroup[]>>(
        `${environment.baseUrl}/v1/AbsenceGroup/searchAbsenceGroups`,
        request
      )
    }

    searchAbsenceGroupsForApproval(request: ISearchAbsenceGroupsRequest){
      return this.http.post<IPagedResults<IAbsenceGroup[]>>(
        `${environment.baseUrl}/v1/AbsenceGroup/searchAbsenceGroupsForApproval`,
        request
      )
    }

    // Whether the "all absences" tab may be opened: supervisor with subordinates, or SearchAll.
    canViewTeamAbsences(){
      return this.http.get<boolean>(
        `${environment.baseUrl}/v1/AbsenceGroup/canViewTeamAbsences`
      )
    }

    // The employees the current user may filter by and record an absence for.
    getVisibleEmployees(){
      return this.http.get<IEmployee[]>(
        `${environment.baseUrl}/v1/AbsenceGroup/getVisibleEmployees`
      )
    }

    canReviewAbsenceGroups(){
      return this.http.get<boolean>(
        `${environment.baseUrl}/v1/AbsenceGroup/canReviewAbsenceGroups`
      )
    }



    deleteAbsenceGroup(id: string){
      return this.http.delete<string>(
        `${environment.baseUrl}/v1/AbsenceGroup/deleteAbsenceGroup/${id}`
      )
    }

    withdrawAbsenceGroup(id: string){
      return this.http.post<string>(
        `${environment.baseUrl}/v1/AbsenceGroup/withdrawAbsenceGroup/${id}`,
        {}
      )
    }

}
